import React from "react";

import { StyledButtonGroup, StyledButton } from "./ButtonGroup.style";

export type OptionType = {
  label: string;
  value: string;
  withDegree?: boolean;
};

const CustomButtonGroup: React.FC<{
  options: OptionType[];
  selectedOption?: OptionType | null;
  handleChange: (newAlignment: OptionType | null) => void;
  onButtonClick?: (event: React.MouseEvent<HTMLElement>) => void;
  disabled?: boolean;
}> = (props) => {
  const [selectedOption, setSelectedOption] = React.useState<
    OptionType | null | undefined
  >(props.selectedOption || null);
  const handleAlignment = React.useCallback(
    (event: React.MouseEvent<HTMLElement>, newAlignment: null | OptionType) => {
      props.handleChange(newAlignment);
      setSelectedOption(newAlignment);
    },
    [props.handleChange]
  );

  React.useEffect(() => {
    setSelectedOption(props.selectedOption);
  }, [props.selectedOption]);

  return (
    <StyledButtonGroup
      value={selectedOption}
      exclusive
      onChange={handleAlignment}
      disabled={props.disabled}
    >
      {props.options.map((option) => (
        <StyledButton
          key={option.value}
          value={option}
          className="toggle-button-item"
          withDegree={option.withDegree}
          sx={{ marginRight: option.withDegree ? "15px" : "0" }}
          onClick={(event) => {
            option.withDegree &&
              props.onButtonClick &&
              props.onButtonClick(event);
          }}
        >
          {option.label}
        </StyledButton>
      ))}
    </StyledButtonGroup>
  );
};

export default CustomButtonGroup;
